export const warriorSprites = [
    "1_1", "1_2", "1_3", "1_4", "2_1", "2_2", "2_6", "2_7", "3_1", "3_6",
    "3_8", "4_7", "4_8", "5_1", "5_2", "5_4", "6_8", "7_1", "7_4", "mil1_7",
    "mil1_8",
];
export const whiteMageSprites = [
    "1_7", "1_8", "2_8", "3_3", "4_6", "5_6", "6_4", "7_3", "7_7",
];
export const blackMageSprites = [
    "1_5", "1_6", "2_3", "3_2", "4_3", "3_5", "4_5", "5_5", "5_7", "7_6",
];
export const thiefSprites = [
    "2_4", "2_5", "3_4", "3_7", "4_2", "5_3", "6_1", "6_2", "6_7",
];

export const femaleSprites = ['1_2', '1_4', '1_5','1_6','1_7','1_8','2_8','3_1',
    '3_2','3_3','3_6','4_3','4_6','5_3','5_5','6_4','6_5', '7_6'
];

export const aiSprites = ['mil1_3'];

export const allSprites = [
    ...warriorSprites,
    ...whiteMageSprites,
    ...blackMageSprites,
    ...thiefSprites,
    ...aiSprites,
];
